import React, { useState, useEffect } from 'react';
import {
  Col, Form, Input, Row, Select, Button, Grid, InputNumber, Spin,
  notification, Tabs, Space,
  Modal,
  message
} from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useConfigQuery } from '../../../../queries/useConfig';
import axiosInstance from '../../../../axiosInterceptor';
import { faArrowsRotate, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WarningOutlined } from '@ant-design/icons';
import { api } from '../../../../config/api';

const { useBreakpoint } = Grid;

const FormularioDeCadastroFiscal = ({ onClose, cadastro, setCadastro, onSaved }) => {
  const { data: config } = useConfigQuery();
  const [form] = useForm();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");

  // ==================== FORMATADOR BRASILEIRO ====================
  const formatDecimalBR = (value) => {
    if (value === null || value === undefined) return '';
    return value.toString().replace('.', ',');
  };

  const parseDecimalBR = (value) => {
    if (!value) return null;
    return parseFloat(value.toString().replace(',', '.'));
  };


  // ==================== DUPLICAR ====================
  const handleDuplicar = () => {
    const currentValues = form.getFieldsValue(true);

    const novoCadastro = {
      ...currentValues,
      id: undefined,
      ncm: '',                    // limpa
      cest: '',                   // limpa
      descricao: currentValues.descricao
        ? `${currentValues.descricao} - Cópia`
        : 'Cópia de cadastro fiscal',
    };
    console.log(novoCadastro);
    setCadastro(novoCadastro);
    form.setFieldsValue(novoCadastro);

    notification.info({
      message: 'Cadastro Duplicado',
      description: 'NCM e CEST foram limpos. Os demais campos foram mantidos.',
    });
  };

  // ==================== EXCLUIR ====================
  const handleExcluir = async () => {
    if (!cadastro?.id) return;
    if (!window.confirm('Tem certeza que deseja excluir este cadastro fiscal?')) return;

    setIsLoading(true);
    try {
      await axiosInstance.delete(
        `${api.techspdv}/api/cadastro-fiscal/${cadastro.id}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      notification.success({ message: 'Sucesso', description: 'Cadastro excluído com sucesso!' });
      onClose?.();
    } catch (error) {
      notification.error({ message: 'Erro', description: 'Falha ao excluir cadastro fiscal' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAtualizarTodos = () => {
    if (!cadastro?.ncm) {
      message.error('Salve o cadastro fiscal antes de atualizar todos os produtos.');
      return;
    }

    Modal.confirm({
      title: '🚨 ATENÇÃO - OPERAÇÃO MUITO DRÁSTICA',
      icon: <FontAwesomeIcon icon={faSyncAlt} style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Você está prestes a <strong>substituir os dados fiscais de TODOS os produtos</strong> da loja por:</p>
          <p style={{ fontSize: '22px', fontWeight: 'bold', color: '#d4380d', textAlign: 'center', margin: '20px 0' }}>
            NCM {cadastro.ncm}
          </p>
          <p><strong>Todos os produtos da loja terão exatamente estes dados fiscais.</strong></p>
          <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>Esta ação é irreversível!</p>
        </div>
      ),
      okText: 'SIM, ATUALIZAR TODOS OS PRODUTOS',
      cancelText: 'CANCELAR',
      okButtonProps: { danger: true },

      onOk: async () => {
        const hideLoading = message.loading('Aplicando dados fiscais em TODOS os produtos...', 0);

        try {
          const payload = {
            idLoja: config?.idLoja,
            ncm: cadastro.ncm,
            cest: cadastro.cest,
            cfop: cadastro.cfop,
            origem: cadastro.origem,
            cst: cadastro.cst,
            descricao: cadastro.descricao,

            // Nomes que o DTO realmente aceita (minúsculos)
            picms: cadastro.pIcms ?? cadastro.picms ?? 0,
            cstPis: cadastro.cstPis,
            ppis: cadastro.pPis ?? cadastro.ppis ?? 0,
            cstCofins: cadastro.cstCofins,
            pcofins: cadastro.pCofins ?? cadastro.pcofins ?? 0,

            ibscbsCst: cadastro.ibscbsCst,
            cclassTrib: cadastro.cClassTrib,
            pibsuf: cadastro.pIbsuf,
            pibsMun: cadastro.pIbsMun,
            pcbs: cadastro.pCbs,
          };

          const response = await axiosInstance.post(
            `${api.techspdv}/api/cadastro-fiscal/cadastro-fiscal/aplicar-em-todos-produtos`,
            payload,
            { headers: { Authorization: `Bearer ${accessToken}` } }
          );

          hideLoading();
          message.success(`${response.data.totalAtualizados} produtos atualizados com sucesso!`);

        } catch (error) {
          hideLoading();
          message.error(error.response?.data?.message || 'Erro ao atualizar todos os produtos');
        }
      },
    });
  };

  // ==================== SALVAR ====================
  const onFinish = async (values) => {
    setIsLoading(true);
    const somenteNumeros = (valor = "") => {
      return String(valor).replace(/\D/g, "");
    };
    const allValues = form.getFieldsValue(true);

    const payload = {
      id: allValues.id,
      idLoja: config?.idLoja,
      ncm: somenteNumeros(allValues.ncm),
      cest: somenteNumeros(allValues.cest),
      descricao: allValues.descricao,
      cfop: allValues.cfop,
      origem: allValues.origem,
      cst: allValues.cst,

      picms: allValues.pIcms,
      cstPis: allValues.cstPis,
      ppis: allValues.pPis,
      cstCofins: allValues.cstCofins,
      pcofins: allValues.pCofins,

      ibscbsCst: allValues.ibscbsCst,
      cclassTrib: allValues.cClassTrib,
      pibsuf: allValues.pIbsuf,
      pibsMun: allValues.pIbsMun,
      pcbs: allValues.pCbs,
    };

    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      let resp;
      if (cadastro?.id) {
        resp = await axiosInstance.put(
          `${api.techspdv}/api/cadastro-fiscal/${cadastro.id}`,
          payload,
          options
        );
      } else {
        resp = await axiosInstance.post(
          `${api.techspdv}/api/cadastro-fiscal`,
          payload,
          options
        );
      }

      notification.success({
        message: 'Sucesso',
        description: cadastro?.id ? 'Cadastro atualizado!' : 'Cadastro criado com sucesso!'
      });

      setCadastro?.(resp.data);
      onSaved?.(resp.data);
      onClose?.();
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Erro', description: 'Falha ao salvar cadastro fiscal' });
    } finally {
      setIsLoading(false);
    }
  };

  // ==================== ATUALIZAR PRODUTOS COM ESTE NCM ====================
  const handleAtualizarProdutosNCM = async () => {
    if (!cadastro?.id || !cadastro?.ncm) {
      message.error('NCM inválido ou cadastro não salvo');
      return;
    }

    Modal.confirm({
      title: '⚠️ Atualizar Produtos',
      icon: <FontAwesomeIcon icon={faArrowsRotate} style={{ color: '#faad14' }} />,
      content: (
        <div>
          <p>Você está prestes a atualizar <strong>todos os produtos</strong> que usam o NCM:</p>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#d4380d', textAlign: 'center', margin: '16px 0' }}>
            {cadastro.ncm}
          </p>
          <p><strong>Esta ação não pode ser desfeita.</strong></p>
        </div>
      ),
      okText: 'SIM, ATUALIZAR',
      cancelText: 'Cancelar',
      okButtonProps: { danger: true },

      onOk: async () => {
        setIsLoading(true);

        // Cria o loading e guarda a referência para fechar depois
        const hideLoading = message.loading('Aplicando dados fiscais nos produtos...', 0);

        try {
          const payload = {
            idLoja: config?.idLoja,
            ncm: cadastro.ncm,
          };

          const response = await axiosInstance.post(
            `${api.techspdv}/api/cadastro-fiscal/aplicar-produtos`,
            payload,
            { headers: { Authorization: `Bearer ${accessToken}` } }
          );

          const { quantidadeAtualizada } = response.data || {};

          hideLoading(); // ← Fecha o loading

          message.success({
            content: `${quantidadeAtualizada || 0} produto(s) atualizado(s) com sucesso!`,
            duration: 6,
          });

        } catch (error) {
          hideLoading(); // ← Muito importante: fecha o loading em caso de erro

          console.error(error);

          const errorMsg = error.response?.data?.message ||
            error.response?.status === 405 ? 'Método não permitido (405)' :
            'Erro ao atualizar os produtos';

          message.error({
            content: errorMsg,
            duration: 8,
          });

        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  // ==================== CARREGAR DADOS PARA EDIÇÃO ====================
  useEffect(() => {
    if (cadastro?.id && form) {
      console.log('Carregando cadastro:', cadastro.ncm); // ← para debug

      const timeoutId = setTimeout(() => {
        form.resetFields();

        form.setFieldsValue({
          id: cadastro.id,
          ncm: cadastro.ncm || '',           // ← mais explícito
          cest: cadastro.cest || '',
          descricao: cadastro.descricao || '',
          cfop: cadastro.cfop || '',
          origem: cadastro.origem || '0',
          cst: cadastro.cst || '102',

          pIcms: cadastro.picms ?? cadastro.pIcms ?? 0,
          cstPis: cadastro.cstPis || '',
          pPis: cadastro.ppis ?? cadastro.pPis ?? 0,
          cstCofins: cadastro.cstCofins || '',
          pCofins: cadastro.pcofins ?? cadastro.pCofins ?? 0,

          ibscbsCst: cadastro.ibscbsCst || '',
          cClassTrib: cadastro.cclassTrib || cadastro.cClassTrib || '',
          pIbsuf: cadastro.pibsuf ?? cadastro.pIbsuf ?? 0,
          pIbsMun: cadastro.pibsMun ?? cadastro.pIbsMun ?? 0,
          pCbs: cadastro.pcbs ?? cadastro.pCbs ?? 0,
        });

        console.log('setFieldsValue NCM =', cadastro.ncm); // ← debug
      }, 180);

      return () => clearTimeout(timeoutId);
    }
  }, [cadastro?.id, form]);
  // Forçar atualização quando trocar de aba
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (cadastro) form.setFieldsValue(form.getFieldsValue(true));
    }, 300);
    return () => clearTimeout(timeout);
  }, [cadastro]);

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1>{cadastro?.id ? `Editar Cadastro Fiscal - ${cadastro.ncm}` : 'Novo Cadastro Fiscal'}</h1>
      </header>

      <Form
        form={form}
        layout={isMobile ? 'vertical' : 'horizontal'}
        labelCol={isMobile ? undefined : { span: 8 }}
        wrapperCol={isMobile ? undefined : { span: 16 }}
        onFinish={onFinish}
        initialValues={{
          origem: '0',
          cst: '102',
          cstPis: '07',
          cstCofins: '07',
          pIcms: 0,
          pPis: 0,
          pCofins: 0,
          ibscbsCst: '000',
          cClassTrib: '000001',
          pIbsuf: 0.1,
          pIbsMun: 0,
          pCbs: 0.9,
        }}
      >
        <Tabs defaultActiveKey="1">
          {/* ABA 1 - Dados Básicos */}
          <Tabs.TabPane tab="Dados Básicos" key="1">
            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item label="NCM" name="ncm" rules={[{ required: true }]}>
                  <Space.Compact style={{ width: '100%' }}>
                    <Input
                      placeholder="Ex.: 19059010"
                      maxLength={10}
                      disabled={!!cadastro?.id}
                      value={cadastro?.ncm || undefined}
                    />
                    {cadastro?.id && (
                      <Button
                        type="primary"
                        icon={<FontAwesomeIcon icon={faArrowsRotate} />}
                        onClick={handleAtualizarProdutosNCM}
                        loading={isLoading}
                        style={{ backgroundColor: "black", borderColor: "black" }}
                      >
                        Atualizar Produtos com este NCM
                      </Button>
                    )}
                  </Space.Compact>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="CEST" name="cest" rules={[{ required: true }]}>
                  <Input placeholder="Ex.: 01010101" maxLength={10} />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="CFOP" name="cfop">
                  <Input placeholder="5102" maxLength={10} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Origem" name="origem">
                  <Select placeholder="Selecione a origem">
                    <Select.Option value="0">0 - Nacional</Select.Option>
                    <Select.Option value="1">1 - Estrangeira - Importação Direta</Select.Option>
                    <Select.Option value="2">2 - Estrangeira - Mercado Interno</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="CST" name="cst">
                  <Input placeholder="102" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="Descrição" name="descricao" rules={[{ required: true }]}>
                  <Input placeholder="Descrição do produto / NCM" maxLength={50} />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          {/* ABA 2 - Impostos com formato brasileiro */}
          <Tabs.TabPane tab="Impostos" key="2">
            <Row gutter={[16, 12]}>
              <Col xs={24} lg={12}>
                <Form.Item label="Alíquota ICMS (%)" name="pIcms">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="CST PIS" name="cstPis">
                  <Input placeholder="07" />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="Alíquota PIS (%)" name="pPis">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="CST COFINS" name="cstCofins">
                  <Input placeholder="07" />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="Alíquota COFINS (%)" name="pCofins">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Reforma Tributária" key="3">
            <Row gutter={[16, 12]}>
              <Col xs={24} lg={12}>
                <Form.Item label="CST IBS/CBS" name="ibscbsCst">
                  <Input placeholder="000" />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="cClassTrib" name="cClassTrib">
                  <Input placeholder="000001" />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="pIBS UF (%)" name="pIbsuf">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="pIBS Mun (%)" name="pIbsMun">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="pCBS (%)" name="pCbs">
                  <InputNumber
                    style={{ width: '100%' }}
                    precision={4}
                    formatter={formatDecimalBR}
                    parser={parseDecimalBR}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>

        {/* ==================== BOTÕES ==================== */}
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          {/* Botão à ESQUERDA */}
          {cadastro?.id && (
            <Button
              danger
              type="primary"
              icon={<WarningOutlined />}          
              onClick={handleAtualizarTodos}
              loading={isLoading}
              style={{
                backgroundColor: "#d32f2f",       
                borderColor: "#d32f2f",
                color: "white"
              }}
            >
              Atualizar Todos os Produtos
            </Button>
          )}

          {/* Botões à DIREITA */}
          <Space wrap>
            {cadastro?.id && (
              <Button
                danger
                type="primary"
                onClick={handleExcluir}
                loading={isLoading}
                style={{ backgroundColor: "red", borderColor: "red" }}
              >
                Excluir Cadastro
              </Button>
            )}

            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              style={{ backgroundColor: "black", borderColor: "black", color: "white" }}
            >
              {cadastro?.id ? 'Salvar' : 'Criar'} Cadastro Fiscal
            </Button>

            {cadastro?.id && (
              <Button type="default" onClick={handleDuplicar}>
                Duplicar Cadastro Fiscal
              </Button>
            )}
          </Space>
        </div>
      </Form>
    </div>
  );
};

const styles = {
  container: { padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" },
  header: { marginBottom: "20px" },
};

export default FormularioDeCadastroFiscal;